import styled from 'styled-components';

import Button from '../../../components/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 6px;
  height: 550px;
  width: 490px;
  line-height: 18px;
  margin: 55px 0;

  > svg {
    color: ${(props) => props.theme.colors.primary};
    cursor: pointer;
    position: relative;
    right: 200px;
    top: -45px;
  }

  h1 {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
  }

  h2 {
    font-size: 14px;
    font-weight: 400;
    margin-top: 15px;
    max-width: 275px;
  }

  p {
    color: #a6a3a3;
    font-size: 12px;
    margin-top: 15px;
    max-width: 275px;
  }

  form {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    min-width: 275px;
  }
`;

export const Field = styled.div`
  font-size: 14px;

  & + div {
    margin-top: 20px;
  }

  > div {
    height: 40px;
    margin-top: 5px;
  }

  input {
    font-size: 14px;
  }
`;

export const SaveButton = styled(Button)`
  align-self: center;
  font-size: 14px;
  margin-top: 35px !important;
  min-width: 152px;
  text-transform: none;
`;
